/* GET LEAD_PRICES */
export const GET_CALLS = "GET_CALLS"
export const GET_CALLS_SUCCESS = "GET_CALLS_SUCCESS"
export const GET_CALLS_ERROR = "GET_CALLS_ERROR"
export const UPDATE_CALL = "UPDATE_CALL"
export const UPDATE_CALL_SUCCESS = "UPDATE_CALL_SUCCESS"
export const UPDATE_CALL_ERROR = "UPDATE_CALL_ERROR"
export const GET_CALL_TRANSCRIPTION = "GET_CALL_TRANSCRIPTION"
export const GET_CALL_TRANSCRIPTION_SUCCESS = "GET_CALL_TRANSCRIPTION_SUCCESS"
export const GET_CALL_TRANSCRIPTION_ERROR = "GET_CALL_TRANSCRIPTION_ERROR"
export const GET_CALL_TRANSCRIPTION_SETTINGS = "GET_CALL_TRANSCRIPTION_SETTINGS"
export const GET_CALL_TRANSCRIPTION_SETTINGS_SUCCESS = "GET_CALL_TRANSCRIPTION_SETTINGS_SUCCESS"
export const GET_CALL_TRANSCRIPTION_SETTINGS_ERROR = "GET_CALL_TRANSCRIPTION_SETTINGS_ERROR"
export const UPDATE_CALL_TRANSCRIPTION_SETTINGS = "UPDATE_CALL_TRANSCRIPTION_SETTINGS"
export const UPDATE_CALL_TRANSCRIPTION_SETTINGS_SUCCESS = "UPDATE_CALL_TRANSCRIPTION_SETTINGS_SUCCESS"
export const UPDATE_CALL_TRANSCRIPTION_SETTINGS_ERROR = "UPDATE_CALL_TRANSCRIPTION_SETTINGS_ERROR"
export const GET_CALL_TRANSCRIPTION_TOPICS = "GET_CALL_TRANSCRIPTION_TOPICS"
export const GET_CALL_TRANSCRIPTION_TOPICS_SUCCESS = "GET_CALL_TRANSCRIPTION_TOPICS_SUCCESS"
export const GET_CALL_TRANSCRIPTION_TOPICS_ERROR = "GET_CALL_TRANSCRIPTION_TOPICS_ERROR"
export const CREATE_CALL_TRANSCRIPTION_TOPIC = "CREATE_CALL_TRANSCRIPTION_TOPIC"
export const CREATE_CALL_TRANSCRIPTION_TOPIC_SUCCESS = "CREATE_CALL_TRANSCRIPTION_TOPIC_SUCCESS"
export const CREATE_CALL_TRANSCRIPTION_TOPIC_ERROR = "CREATE_CALL_TRANSCRIPTION_TOPIC_ERROR"
export const UPDATE_CALL_TRANSCRIPTION_TOPIC = "UPDATE_CALL_TRANSCRIPTION_TOPIC"
export const UPDATE_CALL_TRANSCRIPTION_TOPIC_SUCCESS = "UPDATE_CALL_TRANSCRIPTION_TOPIC_SUCCESS"
export const UPDATE_CALL_TRANSCRIPTION_TOPIC_ERROR = "UPDATE_CALL_TRANSCRIPTION_TOPIC_ERROR"
export const DELETE_CALL_TRANSCRIPTION_TOPIC = "DELETE_CALL_TRANSCRIPTION_TOPIC"
export const DELETE_CALL_TRANSCRIPTION_TOPIC_SUCCESS = "DELETE_CALL_TRANSCRIPTION_TOPIC_SUCCESS"
export const DELETE_CALL_TRANSCRIPTION_TOPIC_ERROR = "DELETE_CALL_TRANSCRIPTION_TOPIC_ERROR"
